export default __webpack_public_path__ + "static/media/Landfill_diversion.706b2059.svg";